import { MutationTree } from "vuex";
import { PaymentRequirementsHistoryItem, PaymentRequirementsHistoryParams } from "../../api/history/payment-requirements-history.interface";
import { PaymentRequirementsHistoryMutation } from "./constants";
import { PaymentRequirementsHistoryState } from "./interface";

export default <MutationTree<PaymentRequirementsHistoryState>> {

	[PaymentRequirementsHistoryMutation.setHistoryList](
		state,
		payload: PaymentRequirementsHistoryItem[]
	) {
		state.historyList = payload;
	},

	[PaymentRequirementsHistoryMutation.appendHistoryList](
		state,
		payload: PaymentRequirementsHistoryItem[]
	) {
		state.historyList.push(...payload);
	},

	[PaymentRequirementsHistoryMutation.setHistoryListLoading](
		state,
		payload: boolean
	) {
		state.historyListLoading = payload;
	},

	[PaymentRequirementsHistoryMutation.setHistoryFilters](
		state,
		payload: PaymentRequirementsHistoryParams | null
	) {
		if (!payload) {
			for (const key in state.historyFilters) {
				state.historyFilters[key as keyof PaymentRequirementsHistoryParams] = null as never;
			}
		} else {
			Object.assign(state.historyFilters, payload);
		}
	},

	[PaymentRequirementsHistoryMutation.setHistoryPageIsEnd](
		state,
		payload: boolean
	) {
		state.historyPageIsEnd = payload;
	}

}